// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AzureAksNodePoolMode } from './AzureAksNodePoolMode';
import {
  AzureAksNodePoolModeFromJSON,
  AzureAksNodePoolModeFromJSONTyped,
  AzureAksNodePoolModeToJSON,
  AzureAksNodePoolModeToJSONTyped,
} from './AzureAksNodePoolMode';
import type { AzureAksNodePoolSpotConfig } from './AzureAksNodePoolSpotConfig';
import {
  AzureAksNodePoolSpotConfigFromJSON,
  AzureAksNodePoolSpotConfigFromJSONTyped,
  AzureAksNodePoolSpotConfigToJSON,
  AzureAksNodePoolSpotConfigToJSONTyped,
} from './AzureAksNodePoolSpotConfig';
import type { AzureAksNodePoolTaint } from './AzureAksNodePoolTaint';
import {
  AzureAksNodePoolTaintFromJSON,
  AzureAksNodePoolTaintFromJSONTyped,
  AzureAksNodePoolTaintToJSON,
  AzureAksNodePoolTaintToJSONTyped,
} from './AzureAksNodePoolTaint';

/**
 *
 * @export
 * @interface AzureAksNodePool
 */
export interface AzureAksNodePool {
  /**
   *
   * @type {number}
   * @memberof AzureAksNodePool
   */
  diskSizeGb?: number;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof AzureAksNodePool
   */
  labels?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof AzureAksNodePool
   */
  machineType?: string;
  /**
   *
   * @type {number}
   * @memberof AzureAksNodePool
   */
  maxCount?: number;
  /**
   *
   * @type {number}
   * @memberof AzureAksNodePool
   */
  maxPods?: number;
  /**
   *
   * @type {number}
   * @memberof AzureAksNodePool
   */
  minCount?: number;
  /**
   *
   * @type {AzureAksNodePoolMode}
   * @memberof AzureAksNodePool
   */
  mode?: AzureAksNodePoolMode;
  /**
   *
   * @type {string}
   * @memberof AzureAksNodePool
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof AzureAksNodePool
   */
  nodeCount?: number;
  /**
   *
   * @type {string}
   * @memberof AzureAksNodePool
   */
  nodeImageSnapshot?: string;
  /**
   *
   * @type {string}
   * @memberof AzureAksNodePool
   */
  planeType?: string;
  /**
   *
   * @type {AzureAksNodePoolSpotConfig}
   * @memberof AzureAksNodePool
   */
  spotConfig?: AzureAksNodePoolSpotConfig;
  /**
   *
   * @type {Array<AzureAksNodePoolTaint>}
   * @memberof AzureAksNodePool
   */
  taints?: Array<AzureAksNodePoolTaint>;
}

/**
 * Check if a given object implements the AzureAksNodePool interface.
 */
export function instanceOfAzureAksNodePool(
  value: object,
): value is AzureAksNodePool {
  return true;
}

export function AzureAksNodePoolFromJSON(json: any): AzureAksNodePool {
  return AzureAksNodePoolFromJSONTyped(json, false);
}

export function AzureAksNodePoolFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureAksNodePool {
  if (json == null) {
    return json;
  }
  return {
    diskSizeGb: json['disk_size_gb'] == null ? undefined : json['disk_size_gb'],
    labels: json['labels'] == null ? undefined : json['labels'],
    machineType:
      json['machine_type'] == null ? undefined : json['machine_type'],
    maxCount: json['max_count'] == null ? undefined : json['max_count'],
    maxPods: json['max_pods'] == null ? undefined : json['max_pods'],
    minCount: json['min_count'] == null ? undefined : json['min_count'],
    mode:
      json['mode'] == null
        ? undefined
        : AzureAksNodePoolModeFromJSON(json['mode']),
    name: json['name'] == null ? undefined : json['name'],
    nodeCount: json['node_count'] == null ? undefined : json['node_count'],
    nodeImageSnapshot:
      json['node_image_snapshot'] == null
        ? undefined
        : json['node_image_snapshot'],
    planeType: json['plane_type'] == null ? undefined : json['plane_type'],
    spotConfig:
      json['spot_config'] == null
        ? undefined
        : AzureAksNodePoolSpotConfigFromJSON(json['spot_config']),
    taints:
      json['taints'] == null
        ? undefined
        : (json['taints'] as Array<any>).map(AzureAksNodePoolTaintFromJSON),
  };
}

export function AzureAksNodePoolToJSON(json: any): AzureAksNodePool {
  return AzureAksNodePoolToJSONTyped(json, false);
}

export function AzureAksNodePoolToJSONTyped(
  value?: AzureAksNodePool | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    disk_size_gb: value['diskSizeGb'],
    labels: value['labels'],
    machine_type: value['machineType'],
    max_count: value['maxCount'],
    max_pods: value['maxPods'],
    min_count: value['minCount'],
    mode: AzureAksNodePoolModeToJSON(value['mode']),
    name: value['name'],
    node_count: value['nodeCount'],
    node_image_snapshot: value['nodeImageSnapshot'],
    plane_type: value['planeType'],
    spot_config: AzureAksNodePoolSpotConfigToJSON(value['spotConfig']),
    taints:
      value['taints'] == null
        ? undefined
        : (value['taints'] as Array<any>).map(AzureAksNodePoolTaintToJSON),
  };
}
